<template>
  <div v-if="periodItem.id" class="check-form">
    <a-collapse v-model="key" expand-icon-position="right" style="background-color: white" v-if="showTitle">
      <template #expandIcon="props">
        <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel key="1" >
        <template #header >
          <div class="header-title">
            {{form.name}}
            <a-tag color="green" v-if="form.checked=='1'">
              核查完成
            </a-tag>
          </div>
          <template>
            <a-button v-has="'checkdata:batchCloseQuestion'" style="margin-left: 20px" v-if="questionList.length>0" @click="closeQuestionListHandle">
              批量关闭质疑
            </a-button>
          </template>
          <template v-if="key.length===0">
            <div class="header-info">
              <label class="label">受试者信息：</label>{{patient.patientNum}}/{{patient.name}}
            </div>
            <div class="header-info">
              <label class="label">待关闭质疑数：</label>{{form.questionCount}}
            </div>
            <div class="header-info">
              <label class="label">提交人：</label>{{form.userRealname}}
            </div>
            <div class="header-info">
              <label class="label">提交时间：</label>{{form.submitTime}}
            </div>
          </template>

        </template>
        <a-row :gutter="20">
          <a-col :span="8" >
            <div class="panel-info-title">
              受试者信息
            </div>
            <div class="panel-info">
              受试者编号/姓名：{{patient.patientNum}}/{{patient.name}}<label class="panel-info-label">{{patient.sex=='1'?'男':'女'}}</label><label class="panel-info-label">{{patient.age}}岁</label>
            </div>
            <a-tooltip class="info-row" >
              <template slot="title">
                {{form.description}}
              </template>
              <div class="one-row panel-info">
                备注：{{form.description}}
              </div>
            </a-tooltip>
          </a-col>
          <a-col :span="8" >
            <div class="panel-info-title">
              审核情况
            </div>
            <div class="panel-info">
              <label>表单完成度：{{((form.itemValueCount / form.itemCount) * 100).toFixed(2) +'%'}}</label>
              <label class="panel-info-label">数据修改次数：{{form.valueUpdateCount}}</label>
            </div>
            <div class="panel-info">
              <label>历史总质疑数：{{form.questionAllCount}}</label>
              <label class="panel-info-label">当前待关闭质疑数：{{form.questionCount}}</label>
            </div>
            <div class="panel-info">
              <label>表单语音质量：{{form.voiceEvaluate}}</label>
            </div>
          </a-col>
          <a-col :span="8" >
            <div class="panel-info-title">
              表单信息
            </div>
            <div class="panel-info">
              <label>提交人：{{form.userRealname}}</label>
              <label class="panel-info-label">提交时间：{{form.submitTime}}</label>
            </div>
            <div class="panel-info">
              <label>最近更新人：{{form.updateByName || '-'}}</label>
              <label class="panel-info-label">最近更新时间：{{form.updateTime || '-'}}</label>
            </div>
          </a-col>
        </a-row>
      </a-collapse-panel>
    </a-collapse>
    <a-row :gutter="20" style="margin-top: 20px">
      <a-col :span="showFile?17:24" class="panel">
        <div class="row">
        查看内容：
        <a-radio-group v-model="isQuestion" >
          <a-radio-button value="0">
            全部
          </a-radio-button>
          <a-radio-button value="1" v-if="this.questionList.length>0">
            质疑题目
          </a-radio-button>
        </a-radio-group>        
      </div>
        <form-view v-if="form.id && questionListLoaded" :key="'formview-'+isQuestion"  :showQuestionItem="isQuestion==='1'" :questionList="questionList" ref="formView" :show-tip-btn="true" :base-data="form" :readOnly="true">
        </form-view>

      </a-col>
      <a-col :span="7" class="panel" v-if="showFile">
        <div class="center-panel base-file-title">
          原始数据
        </div>
        <recording :showRecorder="false" :patientName="patient.name" :formId="form.id" :formName="form.name" :projectId="patient.projectId" :patientId="patient.id"></recording>
      </a-col>
    </a-row>
    <a-modal
      title="批量关闭质疑"
      :width="1000"
      :visible="closeQuestionListVisible"
      :confirmLoading="loading"
      @ok="handleCloseQuestionListSubmit"
      @cancel="handleCloseQuestionListCancel">
      <a-row style="margin-bottom: 20px">
        <a-col :span="4" style="text-align: right">关闭理由：</a-col>
        <a-col :span="18">
          <div style="margin-bottom: 10px">
            <a-radio-group buttonStyle="solid" v-model="questionForm.handleInfo">
              <a-radio value="已修改">已修改</a-radio>
              <a-radio value="无需修改">无需修改</a-radio>
              <a-radio value="-1">其他</a-radio>
            </a-radio-group>
          </div>
          <div v-if="questionForm.handleInfo==='-1'">
            <a-textarea :rows="2"  placeholder="请输入" v-model="questionForm.description" />
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="4" style="text-align: right">质疑元素：</a-col>
        <a-col :span="18">
          <a-table
            size="middle"

            rowKey="id"
            :columns="questionColumns"
            :dataSource="questionList"
            :pagination="false"
            :rowSelection="{selectedRowKeys:questionSelectedRowKeys, onChange: onQuestionSelectChange, type: 'checkbox'}"
            :loading="loading"
            >
          </a-table>
        </a-col>
      </a-row>
    </a-modal>
  </div>
  <a-empty
    v-else
  >
    <span slot="description"> 正在加载数据</span>

  </a-empty>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'
  import FormView from '../components/FormView'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import Recording from '@/views/project/patient/components/recording/Index'
  export default {
    name: 'CheckForm',
    components: { ATextarea, FormView,Recording },
    provide(){
      return{
        parentLoadData:this.loadData,
      }
    },
    props:{
      formId:{
        type:String,
        default:''
      },
      showTitle:{
        type:Boolean,
        default:true
      },
      showFile:{
        type:Boolean,
        default:true
      }
    },
    data(){
      return {
        key:[],
        form:{},
        patient:{},
        periodItem:{},
        opList:[],
        questionList:[],
        loading:false,
        closeQuestionListVisible: false,
        questionSelectedRowKeys:[],
        questionForm:{
          handleInfo:'',
          description:''
        },
        questionColumns:[
          {
            title: '元素名称',
            align: "center",
            dataIndex: 'formItemName',
            width: 200
          },
          {
            title: '相关质疑',
            align: "center",
            dataIndex: 'description',
            width: 200
          },
        ],
        isQuestion:"1",
        questionListLoaded: false
      }
    },
    watch:{
      formId(){
        this.loadData()
      }
    },
    mounted() {
      this.loadData()
    },
    methods:{
      loadData(){
        const patientFormId = this.formId || this.$route.params.id
        getAction('/patient/patient/getFormViewInfo',{patientFormId:patientFormId}).then(res=>{
          if(res.success){
            //加载患者信息，
            //加载所在周期信息
            //加载周期的表单信息
            //加载表单信息
            this.form = res.result.form
            this.periodItem = res.result.periodItem
            this.patient = res.result.patient

            this.loadQuestionList();
            getAction('/patient/patientFormItemOp/list',{formId:patientFormId}).then(res=>{
              if(res.success){
                this.opList = res.result
              }
            })
          }
        })        
      },
      loadQuestionList(){
        this.loading = true
        //获取当前表单的质疑记录
        getAction('/question/patientQuestion/listAll',{projectId:this.form.projectId,status:'1',formId:this.form.id}).then(res=>{
          if(res.success){
            this.questionList = res.result
            if(this.questionList.length==0){
              this.isQuestion = '0'
            }
          }
        }).finally(()=>{
          this.loading = false
          this.questionListLoaded = true // 数据加载完成
        })
      },
      closeQuestionListHandle(e){
        // 阻止事件冒泡
        e.stopPropagation()
        this.closeQuestionListVisible = true
      },
      handleCloseQuestionListSubmit(){
        if(this.questionSelectedRowKeys.length===0){
          return this.$message.warning('请选择质疑元素')
        }
        if(!this.questionForm.handleInfo){
          return this.$message.warning('请选择关闭理由')
        }
        const params = {
          idList:this.questionSelectedRowKeys,
          projectId:this.form.projectId
        }
        if(this.questionForm.handleInfo==='-1'){
          if(!this.questionForm.description){
            return this.$message.warning('请输入“其他”关闭理由')
          }else{
            params.description = this.questionForm.description
          }
        }else{
          params.description = this.questionForm.handleInfo
        }
        postAction('/question/patientQuestion/closeList',params).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.loadQuestionList();
            this.handleCloseQuestionListCancel()
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      handleCloseQuestionListCancel(){
        this.closeQuestionListVisible = false
      },
      onQuestionSelectChange(selectedRowKeys, selectedRows) {
        this.questionSelectedRowKeys = selectedRowKeys;
      },
    }
  }
</script>

<style scoped lang="less">
  .check-form{
    padding: 10px;
  }
  .header-title{
    font-size: 18px;
    font-weight: bold;
    float: left;
  }
  .header-info{
    float: right;
    margin-right: 10px;
    .label{
      color: rgba(0,0,0,0.5);
    }
  }
  .panel-info-title{
    color: @primary-color;
    font-weight: bold;
    font-size: 16px;
  }
  .panel-info{
    margin-top: 5px;
    color: rgba(0,0,0,0.6);
  }
  .panel-info-label{
    margin-left: 30px;
  }
  .record{
    border:1px solid rgba(57,188,206,0.5);
    border-radius: 5px;
    padding: 10px;
  }
  .panel{
  }
  .base-file-title{
    font-size: 18px;
    font-weight: bold;
    .title{
      color: @primary-color;
      font-size: 20px;
    }
  }
</style>
<style lang="less">
  .check-form{
    .ant-collapse-header{
      height: 60px ;
      line-height: 35px !important;
    }
  }
</style>